import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedCategory(value);
    if (value) {
      window.open(value, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-4 tracking-wide">
            BROWSE PRODUCTS
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Explore <span className="text-primary-500">Spreadsheet Categories</span>
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Select a category from the dropdown or click any category button below to discover curated product finds in our Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none px-5 py-3.5 bg-background-100 border border-background-300 rounded-xl text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all duration-200"
            >
              <option value="">-- Select a Category --</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-300 text-center whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}